module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=KY - Cayman Islands.9ebdd9fc.svg";